<template>
    <div class="verifiedEmail">
        <header-comp></header-comp>
        <resend-verified></resend-verified>
        <div class="verifiedEmail-wrap">
            <img src="@/assets/img/pages/registerFlow/email.svg" alt="">
            <h1>註冊驗證信件已送出</h1>
            <div class="description">
                您將收到一封來自飛豬管家的註冊驗證信，<br>
                麻煩至信箱查收以完成註冊流程。<br>
                如果沒有收到認證信，可以 <span class="resend" @click="resendEmail()">按此重發</span>
            </div>
        </div>
        <footer-comp></footer-comp>
    </div>
</template>
<script>
import Header from '@/components/bussiness/header.vue';
import Footer from '@/components/Footer.vue';
import { mapGetters } from 'vuex'
import resendVerified from '@/components/bussiness/widges/modals/resendVerified.vue';

export default {
    methods: {
        resendEmail: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'resendEmailVerified'})
        }
    },
    components: {
        'header-comp': Header,
        'footer-comp': Footer,
        resendVerified
    }
}
</script>
<style lang="scss" scoped>
    .verifiedEmail{
        position: relative;
        background: #F6F6F6;
        >.verifiedEmail-wrap{
            position: relative;
            border-radius: 6px;
            top: 125px;
            width: 266px;
            background: #FFF;
            margin: 0 auto;
            margin-bottom: 208px;
            padding: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            img{
                margin-bottom: 20px;
            }
            h1{
                font-size: 24px;
                margin-bottom: 20px;
            }
            .description{
                text-align: center;
                line-height: 1.5;
                .resend{
                    color: #ff9275;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
    @media screen and (max-width: 375px) {
        .verifiedEmail{
            position: relative;
            >.verifiedEmail-wrap{
                padding: 30px;
            }
        }
    }
    @media screen and (max-width: 320px) {
        .verifiedEmail{
            position: relative;
            >.verifiedEmail-wrap{
                padding: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/registerFlow/verifiedEmailHasSent.vue